import IndexPage from "./pages";
import { Web3ReactProvider } from "@web3-react/core";
import { getLibrary } from "utils/injected";
import {
  Redirect,
  Switch,
  Route,
  BrowserRouter as Router,
} from "react-router-dom";
import MyPunks from "pages/MyPunks";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import Marketplace from "pages/Marketplace";
// include styles
import "rodal/lib/rodal.css";
import "app.css";
import NFTDetail from "pages/NFTDetaill";

function App() {
  return (
    <Web3ReactProvider getLibrary={getLibrary} id="page-wrap">
      <Router>
        <Switch>
          <Route exact path="/">
            <IndexPage />
          </Route>
          <Route exact path="/my-punks">
            <MyPunks />
          </Route>
          <Route exact path="/marketplace">
            <Marketplace />
          </Route>
          <Route exact path="/detail/:id">
            <NFTDetail />
          </Route>
          <Redirect to="/" />
        </Switch>
      </Router>
      <div className="fixed z-50 w-full" style={{ top: "0", right: "0" }}>
        <ToastContainer className="fixed right-0 top-O z-50" />
      </div>
    </Web3ReactProvider>
  );
}

export default App;
